export default __webpack_public_path__ + "static/media/shareScreen.551cbf31.svg";